/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {StopTimecardRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {StopTimecardResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const stopTimecard = (request: StopTimecardRequest, options?: CashRequestOptions) => post<StopTimecardRequest, StopTimecardResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/StopTimecard", request, {...options, rejectOnError: true })